import React from 'react';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';
import './Chat.css';

export default function ChatTrigger({ onClick, isOpen, badgeCount = 0, hasMentions = false }) {
  const showBadge = !isOpen && badgeCount > 0;

  return (
    <button
      type="button"
      className="chat-trigger bg-blue-600 hover:bg-blue-700 text-white shadow-md rounded-full flex items-center justify-center w-12 h-12 p-0 transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      onClick={onClick}
      title={
        isOpen
          ? 'Close chat'
          : hasMentions
            ? `${badgeCount} new message(s), ${badgeCount} mention(s) – Open to view`
            : `${badgeCount} new message(s)`
      }
      aria-expanded={isOpen}
      aria-label={isOpen ? 'Close chat' : `Open chat${showBadge ? `, ${badgeCount} unread` : ''}`}
    >
      <span className="text-xl inline-flex" aria-hidden="true">
        {isOpen ? <BiChevronUp /> : <BiChevronDown />}
      </span>
      {showBadge && (
        <span className="chat-trigger-badge" aria-hidden="true">
          {badgeCount > 99 ? '99+' : badgeCount}
        </span>
      )}
    </button>
  );
}
